import { PositionConfig } from "slotworks/config/asset-config-schema";
import AnimationManager from "slotworks/graphics/animation/animation-manager";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import { generateButton } from "slotworks/graphics/layers/populators/generate-button";
import { generateToggle } from "slotworks/graphics/layers/populators/generate-toggle";
import ParticleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import Rectangle from "slotworks/utils/geom/rectangle";
import deviceInfo from "slotworks/utils/device-info";

export function populateSprites(sprites: PositionConfig[], layer: Layers) {
    if (sprites) {
        for (const graphicConfig of sprites) {
            const id = graphicConfig.id;
            const name = id.substring(id.lastIndexOf("/") + 1);

            if (name.slice(0, 4) === "btn-") {
                // Buttons
                generateButton(name.substring(4), graphicConfig, layer);
            } else if (name.slice(0, 9) === "particle-") {
                // particles
                const particleInfo = name.split("-");
                const particleId = particleInfo[1];

                const particleContainer = new PIXI.Container();
                const particle = ParticleManager.add(particleId, new Point(graphicConfig.x, graphicConfig.y), particleContainer);

                layer.addParticle(particleId, particle);
                layer.container.addChildAt(particleContainer, 0);
            } else if (name.slice(0, 5) === "anim-") {
                // Animations
                const animOptions = name.split("-");

                const animationId = animOptions[1];
                let instanceId = animationId;
                let autoplay = true;

                if (animOptions.length > 2) {
                    instanceId = animOptions[2];
                    if (instanceId === "true" || instanceId === "false") {
                        autoplay = instanceId === "true";
                        instanceId = animationId;
                    }
                }
                if (animOptions.length > 3) {
                    autoplay = animOptions[3] === "true";
                }

                if (AnimationManager.hasScriptedAnimationFactory(animationId)) {
                    const animPosition = new Rectangle(graphicConfig.x, graphicConfig.y, graphicConfig.width, graphicConfig.height);
                    const anim = AnimationManager.createScriptedAnimation(animationId, animPosition);

                    layer.addScriptedAnimation(instanceId, anim);

                    if (autoplay) {
                        anim.play();
                    } else {
                        anim.getContainer().visible = false;
                    }

                    layer.container.addChildAt(anim.getContainer(), 0);

                } else {
                    const anim = GraphicsManager.createAnimation(animationId);
                    anim.x = graphicConfig.x;
                    anim.y = graphicConfig.y;
                    anim.width = graphicConfig.width;
                    anim.height = graphicConfig.height;
                    anim.name = instanceId;

                    if (autoplay) {
                        anim.play();
                    } else {
                        anim.visible = false;
                    }

                    layer.container.addChildAt(anim, 0);
                }
            } else if (name.slice(0, 6) === "shape-") {
                // Shapes
                const shapeParams = name.slice(6).split("-");

                const shapeName = shapeParams[0];
                const shapeFillColor = parseInt(shapeParams[1], 16);
                const shapeFillAlpha = shapeParams.length > 2 ? parseFloat(shapeParams[2]) / 100 : 1;
                const shapeStrokeColor = shapeParams.length > 3 ? parseInt(shapeParams[3], 16) : shapeFillColor;
                const shapeStrokeSize = shapeParams.length > 4 ? parseFloat(shapeParams[4]) : 0;
                const shapeStrokeAlpha = shapeParams.length > 5 ? parseFloat(shapeParams[5]) / 100 : shapeFillAlpha;

                const shape = new PIXI.Graphics();
                shape.lineStyle(shapeStrokeSize, shapeStrokeColor, shapeStrokeAlpha);
                shape.beginFill(shapeFillColor, shapeFillAlpha);
                shape.drawRect(0, 0, graphicConfig.width, graphicConfig.height);
                shape.x = graphicConfig.x;
                shape.y = graphicConfig.y;
                shape.name = shapeName;

                layer.container.addChildAt(shape, 0);
            } else if (name.slice(0, 4) === "tgl-") {
                // Toggle buttons
                generateToggle(name.substring(4), graphicConfig, layer);
            } else {
                // Sprites
                let sprite;
                if(deviceInfo.hasTwoOrientations()) {
                    const ids = [ id ];
                    ids.unshift(
                        (deviceInfo.layoutPrefix == "portrait-" ? "landscape-" : "portrait-") +
                        id.slice(deviceInfo.layoutPrefix.length, id.length)
                    );
                    sprite = GraphicsManager.createSprite(ids);
                } else {
                    sprite = GraphicsManager.createSprite(id);
                }
                
                sprite.x = graphicConfig.x;
                sprite.y = graphicConfig.y;
                sprite.width = graphicConfig.width;
                sprite.height = graphicConfig.height;
                sprite.name = name;

                layer.container.addChildAt(sprite, 0);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/graphics/layers/populators/populate-sprites.ts